import { EventsCollection } from '@models/EventsCollection'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { EVENTS_COLLECTIONS_URL } from '@utils/urls'

const fetchEventsCollections = (params: TableParams) =>
  SBAPI.FetchPaginated<EventsCollection[]>(EVENTS_COLLECTIONS_URL, params)

const fetchEventsCollectionById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<EventsCollection>(`${EVENTS_COLLECTIONS_URL}/${id}`, params)

const createEventsCollection = (eventsCollection: EventsCollection) =>
  SBAPI.Post(EVENTS_COLLECTIONS_URL, eventsCollection)

const updateEventsCollection = (eventsCollection: EventsCollection) =>
  SBAPI.Put(
    `${EVENTS_COLLECTIONS_URL}/${eventsCollection.id}`,
    eventsCollection
  )

const deleteEventsCollection = (eventsCollection: EventsCollection) =>
  SBAPI.Delete(`${EVENTS_COLLECTIONS_URL}/${eventsCollection.id}`)

const reorderEventsCollection = (orderData: { id: number; order: number }[]) =>
  SBAPI.Post(`${EVENTS_COLLECTIONS_URL}/reorder`, {
    eventCollections: orderData,
  })

export {
  createEventsCollection,
  deleteEventsCollection,
  fetchEventsCollectionById,
  fetchEventsCollections,
  reorderEventsCollection,
  updateEventsCollection,
}
